<template>
    <client-page>
        <sub-visual v-bind="visual" />

        <div class="client-content-wrap pb-0">
            <section class="client-section pb-0">
                <v-container>
                    <business-intro v-bind="intro" />
                </v-container>
            </section>
        </div>
        <div class="client-content-wrap">
            <scrolldown-tail />

            <section class="client-section">
                <v-container>
                    <v-img src="/images/business/domestic/middle/process-list.png" alt="" class="d-md-none" />
                    
                    <div class="d-none d-md-block">
                        <v-row class="process-list row--lg">
                            <v-col v-for="(item, index) in process" :key="index" cols="12" lg="3">
                                <v-card color="#FAFAFA" flat class="process-card">
                                    <v-row class="text-center">
                                        <v-col cols="12">
                                            <v-img :src="`/images/business/domestic/middle/process-${index + 1}.svg`" max-width="80" class="mb-24 mx-auto" />
                                            <!-- <div class="primary--text font-weight-bold font-size-28">0{{ index + 1 }}</div> -->
                                            <div v-html="item.name" class="tit tit--sm primary--text mt-16" />
                                            <div v-html="item.text" class="page-text page-text--lg mt-16" />
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">주요 프로그램</h2>
                    </div>

                    <program-list :items="programs" />
                </v-container>
            </section>
        </div>
        <!-- <section>
            <bottom-banner :item="banner" />
        </section> -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BusinessIntro from "@/components/client/business/business-intro.vue";
import ProgramList from "@/components/client/business/program-list.vue";
import BottomBanner from "@/components/client/business/bottom-banner.vue";
import ScrolldownTail from "@/components/dumb/scrolldown-tail.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        BusinessIntro,
        ProgramList,
        BottomBanner,
        ScrolldownTail,
    },
    data() {
        return {
            visual: {
                sh: "국내복지사업",
                tabActive: "중노년동행사업",
                text: "우리는 단순한 지원을 넘어, 지속 가능한 변화를 만들어 갑니다.",
                bg: "/images/business/domestic/visual.jpg",
                mobile: "/images/business/domestic/mobile-visual.jpg",
            },
            intro: {
                image: "/images/business/domestic/middle/intro.jpg",
                title: "함께 걸어가는 인생의 두 번째 여정",
                texts: "중노년동행사업은 중장년 및 노년층의 삶의 질 향상과 사회적 소외 예방을 목표로, 세대 간 연대와 경제적 자립을 지원하는 프로그램입니다. <br class='d-none d-xl-block' />신체적, 정서적, 경제적 안정에 중점을 둔 다양한 지원과 활동을 통해 행복한 인생 2막을 만들어갑니다.",
            },
            process: [
                {
                    name: "사회적 소외 예방",
                    text: "중노년층의 사회참여 기회를 <br />넓혀 고립을 예방합니다",
                },
                {
                    name: "건강한 삶 지원",
                    text: "신체적·정서적 건강을 위한 <br />전문 프로그램을 제공하고, <br />예방활동을 펼칩니다",
                },
                {
                    name: "자립 지원",
                    text: "취약계층의 자립과 성장 기반을 <br />마련하는 맞춤형 복지사업을 <br />실천합니다",
                },
                {
                    name: "세대 간화합",
                    text: "다양한 세대가 함께 교류하고 <br />협력하여 상호 존중하는 <br />사회를 추구합니다",
                },
            ],
            programs: [
                {
                    image: "/images/business/domestic/middle/program-1.jpg",
                    title: "심리·정서 지원 프로그램",
                    texts: [
                        "전문 상담을 통해 중노년층의 마음 건강 지원",
                        "집단 상담, 개인 상담, 힐링 워크숍 운영",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/middle/program-2.jpg",
                    title: "건강증진 프로그램",
                    texts: [
                        "중노년층에게 맞춘 건강 관리 강의 및 운동 프로그램 제공",
                        "정기적인 건강 체크와 전문가 상담 진행",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/middle/program-3.jpg",
                    title: "경제 자립 지원 프로그램",
                    texts: [
                        "중노년층의 재취업을 위한 직업 교육 및 정보 제공",
                        "금융 상담과 경제적 자립 워크숍 운영",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/middle/program-4.jpg",
                    title: "세대 간 연대 프로그램",
                    texts: [
                        "청소년 및 젊은 세대와 함께하는 멘토링 활동",
                        "지역사회 봉사활동 및 세대 통합 행사 개최",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/middle/program-5.jpg",
                    title: "문화·여가 활동 프로그램",
                    texts: [
                        "중노년층의 여가문화 활성화를 위한 문화 체험 및 동아리 지원",
                        "여행, 공연 관람, 예술 활동 등 다양한 여가 기회 제공",
                        //
                    ],
                },
            ],
            // banner: {
            //     image: "",
            // },
        };
    },
};
</script>

<style lang="scss" scoped>
.process-list {
    > [class*="col"] {
        .process-card {
            padding: 40px 14px;
            height: 100%;
            border-radius: 16px;
            max-width: 400px;
            margin: 0 auto;
            word-break: keep-all;
        }
        &:not(:last-child) {
            .process-card {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    right: 50%;
                    bottom: -28px;
                    transform: translateX(50%) rotate(90deg);
                    width: 24px;
                    height: 24px;
                    background: url(/images/guide/legacy/process-arrow.svg) no-repeat center;
                }
            }
        }
    }
}
@media (min-width: 1024px) {
    .process-list {
        > [class*="col"] {
            &:not(:last-child) {
                .process-card {
                    position: relative;
                    &::after {
                        content: "";
                        position: absolute;
                        right: -32px;
                        bottom: 50%;
                        transform: translatey(50%);
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }
    }
}
</style>